export const REDESIGN_HEADER_HEIGHT_CSS_VARIABLE = 'redesign-header-height';
export const REDESIGN_HEADER_BAR_HEIGHT_CSS_VARIABLE = 'redesign-header-bar-height';
export const currentHeaderHeightPx = () => {
  const heightValue = document.documentElement.style.getPropertyValue(
    `--${REDESIGN_HEADER_HEIGHT_CSS_VARIABLE}`
  );

  return heightValue ? Number(heightValue.split('px')[0]) : 0;
};

// We add an extra pixel padding above the header to handle cases where the browser renderer causes an extra
// pixel spacing above the header to appear
export const HEADER_ADDITIONAL_TOP_PADDING_PX = 1;
